import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'hamburger',
  props: {
    opened: { type: Boolean }
  },
  emits: ["update:opened"],
  setup(__props: any) {

// https://codepen.io/ainalem/pen/wvKOEMV



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    id: "hamburger-icon",
    class: _normalizeClass(['hamburger', 'icon', {menu: true, opened: _ctx.opened}]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('update:opened', !_ctx.opened)), ["stop"]))
  }, _cache[1] || (_cache[1] = [
    _createElementVNode("svg", { viewBox: "0 0 100 100" }, [
      _createElementVNode("path", {
        class: "line line1",
        d: "M 20,29 H 80 C 80,29 94.5,28.812 94.5,66.7 94.5,78 91,81.7 85.26,81.67 79.55,81.67 75,75 75,75 L 25,25"
      }),
      _createElementVNode("path", {
        class: "line line2",
        d: "M 20,50 H 80"
      }),
      _createElementVNode("path", {
        class: "line line3",
        d: "M 20,71 H 80 C 80,71 94.5,71.18 94.5,33.29 94.5,22.02 91,18.3 85.26,18.3 79.55,18.3 75,25 75,25 L 25,75"
      })
    ], -1)
  ]), 2))
}
}

})